import React from 'react';
import styled from 'styled-components';

const Propierties = styled.div`
  font-size: 20px;
  color: #444b62;
  font-family: Roboto;
  letter-spacing: 0px;
  opacity: 1;
  padding-bottom: 4px;
  line-height: 32px;
  margin_top: 13px;
  text-align: center;
  ${({ theme }) => theme.newBreakpoint('sm')} {
    font-size: 23px;
  }
`;

const NoSales = () => <Propierties>Todavía no tienes ventas</Propierties>;

export default NoSales;
